import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ccffa6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "desc" }

import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useError } from '@/store';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props) {

const { error } = storeToRefs(useError());
const { t } = useI18n();
watch(
  () => error.value,
  (newValue) => {
    if (newValue) {
      document.body.style.overflow = 'hidden';
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('ERROR__MODAL_TITLE')), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)(_unref(error))), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})